import * as _ from 'lodash-es';
import { Component, EventEmitter, Input, OnDestroy, OnInit, ChangeDetectionStrategy, input } from '@angular/core';
import { IProgress } from 'src/app/services/loader.service';
import { Subscription } from 'rxjs';
import { MatProgressBar } from '@angular/material/progress-bar';

/** Backdrop and spinner settings (the former ngx-loading cube grid). */
export interface LoaderConfig {
    backdropBorderRadius: string;
    backdropBackgroundColour: string;
    /** Covers the whole viewport instead of the parent element. */
    fullScreenBackdrop: boolean;
    primaryColour: string;
}

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressBar]
})
export class LoaderComponent implements OnInit, OnDestroy {


    get select_mode() {
        if (this.progression?.value === 0) {
            return 'indeterminate';
        } else {
            return 'determinate';
        }
    }

    get loading(): boolean {
        return this._loading;
    }
    @Input() set loading(value: boolean) {
        this._loading = value;
        if (!this._loading) {
            this.progression = undefined;
        }
    };
    protected _progress?: EventEmitter<IProgress>;
    @Input() set progress(value: EventEmitter<IProgress> | undefined) {
        this._progress = value;
        if (this.progress) {
            this.sub.add(this.progress.subscribe(this.onProgress.bind(this)));
        }
    };
    get progress(): EventEmitter<IProgress> | undefined { return this._progress; }

    public _loading: boolean = false;
    public progression?: IProgress;
    protected sub: Subscription = new Subscription();


    readonly config = input<LoaderConfig>({
    backdropBorderRadius: '0',
    backdropBackgroundColour: 'rgba(255,255,255,0.1)',
    fullScreenBackdrop: false,
    primaryColour: '#a5d256',
});

    /** The nine squares of the cube grid. */
    readonly cubes = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    constructor() { }

    ngOnInit(): void { }

    onProgress(progress: IProgress) {
        this.progression = progress;
    }


    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
